export const userProfileInitialState = {
  user: [],
  store: [],
  loading: true
};
